<template>
  <div class="container">
    <div class="nav">
      <!-- <img class="bkIMg" :src='backImg' alt=""> -->
      <img class="nav_anut" :src='auntImg' alt="">
      <div class="nav_text"  v-for="(item ,index) in courseInfo.config" :key="index">{{item.data}}</div>
      <img class="nav_img" :src="imgUrlData.img_url" @click="jumpBanner(imgUrlData.link_id)" alt="">
      <div class="nav_tab">
        <div :class="[item.id==idx?'nav_tab_item_chose':'nav_tab_item']" @click="choseTab(item.id)"  v-for="(item ,index) in courseInfo.menu" :key="index">{{item.name}}</div>
      </div>
      <div class="nav_box">
        <div class="nav_box_item"  v-for="(item ,index) in courseInfo.tMenu" @click="choseTmenu(item.id)" :key="index">
          <template v-if="tidx==item.id">
              <img class="csImg" :src="csImg" alt="">
          </template>
            <template v-if="tidx!=item.id&&item.study_status==1">
                <img class="csImg" :src="wgImg" alt="">
            </template>
            <template v-if="tidx!=item.id&&item.study_status==0">
                <img class="csImg" :src="csdImg" alt="">
            </template>
          <div class="nav_box_item_font">
            <div>{{item.name1}}</div>
            <div>{{item.name}}</div>
          </div>
        </div>
      </div>
      <!-- <img class="nav_kc4" :src='kc4Img' alt="">
      <img class="nav_kc3" :src='kc3Img' alt=""> -->
      <div class="title">所有课程</div>
    </div>
    <div class="content">
      <div class="content_item" v-for="(item ,index) in courseInfo.courseData" :key="index">
        <img class="badge_img" v-if="item.is_tejia" :src='kc7Img' alt="">
        <img class="content_img" :src='item.image' alt="">
        <div class="column">
          <div class="mid_title">{{item.course_name}}</div>
          <div class="rower">
            <div class="content_mid">
              
              <div class="mid_text">{{item.description}}</div>
            </div>
            <div class="content_right">
              <div class="content_right_num">
                <img class="content_right_num_icon" :src='kc6Img' alt="">
                <div class="content_right_num_text">{{item.virtual_study}}人学过</div> 
              </div>
              <div class="content_right_btn" @click="detail(item.url)">查看详情</div>
            </div>
          </div>
        </div>
        
      </div>
     
      
    </div>
    <div class="bottom">
        <div class="bottom_item" @click="toindex()">
          <img class="bottom_icon" :src='ghImg' alt="">
          <div class="bottom_text">小干货</div>
          <!-- <div class="bottom_text_chose">小干货</div> -->
        </div>
        <div class="bottom_item">
          <img class="bottom_icon" :src='kcImg' alt="">
          <!-- <div class="bottom_text">课程</div> -->
          <div class="bottom_text_chose">课程</div>
        </div>
        <div class="bottom_item" @click="toMy()">
          <img class="bottom_icon" :src='mineImg' alt="">
          <div class="bottom_text">我的</div>
        </div>
    </div>
  </div>
</template>
<style lang="stylus" rel="stylesheet/stylus" scoped>
$rem = 100;
.column{
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  box-sizing: border-box;
  width: calc(100% - 120px) ;
}
.rower{
  display: flex;
  flex-direction: row;
  height :60px;
}
.container{
  overflow-y: scroll;
  // font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
  color: rgb(34,34,34);
}
.nav{
  width: 100%;
  position: relative;
  background-color: #fff;
  // height: 220px;
}
.title{
    display: flex;
    /* -webkit-box-align: center; */
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    color: #31285d;
    padding: 18px 0 15px 0;
    background: radial-gradient(circle, #48f4cb 0, #48f4cb 10px, transparent 0, transparent 100%) calc(50% - 36px) 0px, radial-gradient(circle, #fdc82f 0, #fdc82f 6px, transparent 0, transparent 100%) calc(50% + 39px) 6px;
    background-repeat: no-repeat;
    position: relative;
    bottom: 7px;
}
.title::before{
    content: "";
    display: block;
    width: 10px;
    height: 2px;
    border-radius: 2px;
    margin-right: 5px;
    background-color: #31285d;
}
.title::after{
    content: "";
    display: block;
    width:10px;
    height: 2px;
    border-radius: 2px;
    margin-left: 5px;
    background-color: #31285d;
}
.nav_anut{
  position: relative;
  width: 130px;
  left: 5px;
  top: 0px;
}
.nav_text{
  text-align:center;
  font-size :0.30rem;
  color:rgb(34,34,34);
  margin-bottom :6px;
  margin-top :6px;
}
.nav_img{
  width :calc(100% - 20px);
  margin-left :10px;
  border-radius :10px;
  margin-top :6px;
}
.nav_tab{
  display :flex;
  flex-direction :row;
  width :calc(100% - 20px);
  height :30px;
  margin-left :10px;
  background-color: #ececec;
  color: #B3212D;
  border-bottom: 3px solid #B3212D;
  font-size: 14px;
  margin-top :12px;
}
.nav_box{
  display :flex;
  flex-flow: row wrap;
  width :calc(100% - 20px);
  margin-left :10px;
  color: rgb(34,34,34);
  font-size: 14px;
  align-items: center;
  margin-top :15px;
}
.nav_box_item{
  flex: 0 0 25%;
  display :flex;
  flex-direction :row;
  align-items: center;
  margin-bottom :10px
}
.nav_box_item_font{
  color: rgb(34,34,34);
  font-size: 12px;
  margin-left 8px
}
.nav_box_item_font div:nth-child(2){
  margin-top:5px;
}
.csImg{
  width :20px;
  height :20px;
}
.nav_tab_item{
  flex:1;
  display :flex;
  justify-content :center;
  align-items :center;
}
.nav_tab_item_chose{
  flex:1;
  display :flex;
  justify-content :center;
  align-items :center;
  background-color: #cbcbcb;
}
.nav_kc4{
  width: 240px;
  top: 44px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.nav_kc3{
    position: absolute;
    width: 65px;
    top: 112px;
    left: 50%;
    transform: translateX(-50%);
}
.bkIMg{
  width: 100%;
  height: 180px;
}
.content{
  width: 100%;
  margin-bottom :50px;
  padding-bottom:20px;
}
.content_item{
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 90px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 15px;
  position: relative;
  display: flex;
  flex-direction: row;
}
.content_img{
  width: 150px;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  flex: 7;
}
.content_mid{
  // margin-left: 12px;
  flex: 8;
  align-items: center;
    display: flex;
}
.content_right{
  flex: 5;
  display :flex;
  flex-direction :column;
  align-items: center;
  justify-content :flex-end;
}
.mid_title{
  font-weight: 600;
  font-size: 14px;
  color: rgb(34,34,34);
  margin-top :5px;
  margin-bottom 5px;
  line-height: 24px;
 text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
}
.mid_text{
  font-size: 12px;
  color:#1b1243; 
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content_right_btn{
  width:  (200 / $rem) rem;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background-color: #B3212D;
    color: #fff;
    border-radius: 24px;
    font-size: 12px;
    margin-bottom 5px;
    margin-top :5px
}
.content_right_num{
  display :flex;
  flex-direction :row;
  justify-content :center;
  align-items :center
}
.content_right_num_icon{
  width :12px;
  height :12px;
  margin-right :2px;
}
.content_right_num_text{
  font-size 12px;
  color #879AA7;
  margin-top :1px;
}
.bottom{
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
}
.bottom_item{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottom_icon{
  width: 18px;
  height: 18px;
  margin-bottom: 5px;
}
.bottom_text{
  font-size: 14px;
  color: rgb(34,34,34);
}
.bottom_text_chose{
  font-size: 14px;
  color:#B3212D;
}
.badge_img{
   width: 55px;
  height: 55px;
  position: absolute;
    right: -3px;
    top: -3px;
}

</style>

<script>
import NavBar from "../components/NavBar.vue";
import { getmycourse,getnewcourse } from '../apollo/apollo'

export default {
   components: {
    
  },
  data() {
    return {
      backImg:'./static/imgs/kc2.png',
      auntImg:'./static/imgs/xym.png',
      // kc4Img:'./static/imgs/kc4.png',
      // kc3Img:'./static/imgs/kc3.png',
      kc5Img:'./static/imgs/kc5.png',
      kc6Img:'./static/imgs/kc6.png',
      kc7Img:'./static/imgs/kc7.png',
      ghImg:'./static/imgs/gh.png',
      kcImg:'./static/imgs/kcchose.png',
      mineImg:'./static/imgs/mine.png',
      csImg:'./static/imgs/cs.png',
      csdImg:'./static/imgs/csd.png',
      wgImg:'./static/imgs/wg.png',
      getmycourse:getmycourse,
      getnewcourse:getnewcourse,
      getCourse:[],
      courseInfo:{},
      idx:'',
      tidx:'',
      imgUrlData:{},
    }
  },
  computed:{
    
  },
  created() {
    this.initDate()
  },
  mounted(){
 
  },
  methods: {
    //一级
    choseTab(index){
      var formDate={
          menu_id:index,
        }
        getnewcourse(formDate).then(res=>{
        this.courseInfo=res.data.courseInfo;
        this.tidx=''
        this.idx=index;
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    //二级
    choseTmenu(index){
      var formDate={
          menu_id:this.idx,
          tMenu_id:index,
        }
        getnewcourse(formDate).then(res=>{
        this.courseInfo=res.data.courseInfo;
        this.tidx=index;
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    toindex(){
      this.jump('./index')
    },
    toMy(){
     this.jump('./my')
    },
    initDate(){
      document.title=this.$store.state.title;
      // getmycourse().then(res=>{
      //   this.getCourse=res.data.getCourse;
      //   })
      //   .catch(err=>{
      //     this.msgManage(err)
      //   })
        // var formDate={
        //   menu_id:3,
        //   tMenu_id:'',
        // }
        getnewcourse({}).then(res=>{
        this.courseInfo=res.data.courseInfo;
        this.idx=this.courseInfo.menu[0].id;
        this.imgUrlData=this.courseInfo.imgUrlData
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    detail(url){
      window.location.href=url
    },
    jumpBanner(url){
      window.location.href=url
    },

  },
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/course.vue